import { create } from 'zustand';

interface TrackingState {
  lastTrackingId: string | null;
  setLastTrackingId: (id: string | null) => void;
  lastRmaId: string | null;
  setLastRmaId: (id: string | null) => void;
  pendingTrackingId: string | null;
  setPendingTrackingId: (id: string | null) => void;
  currentTrackingId: string;
  setCurrentTrackingId: (id: string) => void;
  reset: () => void;
}

export const useTrackingStore = create<TrackingState>((set) => ({
  lastTrackingId: null,
  setLastTrackingId: (id: string | null) => set({ lastTrackingId: id }),
  lastRmaId: null,
  setLastRmaId: (id: string | null) => set({ lastRmaId: id }),
  pendingTrackingId: null,
  setPendingTrackingId: (id: string | null) => set({ pendingTrackingId: id }),
  currentTrackingId: '',
  setCurrentTrackingId: (id: string) => set({ currentTrackingId: id }),
  reset: () => set({ lastTrackingId: null, lastRmaId: null, pendingTrackingId: null }),
}));
